<template>
  <div class="addAndModify">
    <el-container>
      <el-main ref="main" class="tabWrap">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="标题：">
                    <el-input v-model="dataForm.title" placeholder="请输入标题" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文字号：">
                    <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文分类：">
                    <el-select v-model="dataForm.documentTypeId" style="width: 100%;" disabled placeholder="请选择发文分类">
                      <el-option :label="deptItem.name" :value="deptItem.id" v-for="(deptItem,deptIndex) in typeList" :key="'deptItem'+deptIndex"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文日期：">
                    <el-date-picker
                        v-model="dataForm.documentDate"
                        value-format="yyyy-MM-dd"
                        :readonly="true"
                        type="date"
                        placeholder="请选择发文日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label-width="120px" label="拟稿部门：">-->
                <!--                    <el-input v-model="dataForm.documentDraftDeptId" placeholder="请输入拟稿部门" clearable></el-input>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label-width="120px" label="拟稿日期：">
                    <el-date-picker
                        v-model="dataForm.documentDraftDate"
                        value-format="yyyy-MM-dd"
                        :readonly="true"
                        type="date"
                        placeholder="请选择拟稿日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="核稿日期：">
                    <el-date-picker
                        v-model="dataForm.documentApproveDate"
                        value-format="yyyy-MM-dd"
                        :readonly="true"
                        type="date"
                        placeholder="请选择核稿日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
<!--                <el-col :span="8">-->
<!--                  <el-form-item label-width="120px" label="接收人：">-->
<!--                    <el-input v-model="dataForm.receiveUser" :readonly="true" clearable></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label-width="120px" label="处理人：">
                    <el-input v-model="dataForm.operateUserName" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="处理时间：">
                    <el-date-picker
                        v-model="dataForm.operateTime"
                        value-format="yyyy-MM-dd"
                        :readonly="true"
                        type="date">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                        label="拟稿部门："
                        label-width="120px"
                        ref="sendListRef"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                            v-for="(tag, index) in dataForm.documentDraftDeptJson"
                            :key="index"
                            style="margin-right: 5px;"
                        >{{ tag.name }}</el-tag
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                        label="主送："
                        label-width="120px"
                        ref="sendListRef"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                            v-for="(tag, index) in dataForm.sendListJson"
                            :key="index"
                            style="margin-right: 5px;"
                        >{{ tag.displayName || tag.name }}</el-tag
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                        label="抄送："
                        label-width="120px"
                        ref="ccListRef"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                            v-for="(tag, index) in dataForm.ccListJson"
                            :key="index"
                            style="margin-right: 5px;"
                        >{{ tag.displayName || tag.name }}</el-tag
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <el-form-item class="maxWidth" label-width="120px" label="备注：">
                    <el-input v-model="dataForm.remark" placeholder="请输入备注信息" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="Tab2">
            <div>
              <el-table :data="fileList"
                        style="width: 100%; margin: 20px"
                        size="mini"
                        border>
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column
                    v-for="(prop, index) in tableProps"
                    :key="index"
                    :prop="prop.prop"
                    :label="prop.label"
                    :min-width="prop.width"
                ></el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="downloadFile(scope.$index, scope.row)"
                        type="text"
                    >下载附件</el-button>
                    <el-button
                        size="mini"
                        @click="previewFile(scope.$index, scope.row,'document')"
                        type="text"
                    >预览</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审批流程" name="Tab3" style="height: 700px;overflow-y: auto">
            <div v-if="approveFlag === 'currentApprove'">
              <approveItem
                  :itemId="contractId"
                  :approveType="approveType"
                  :subapproveType="subapproveType"
                  @finishApprove="close()"
              >
              </approveItem>
            </div>
            <div v-else>
              <approveLine
                  :itemId="contractId"
                  :approveType="approveType"
              ></approveLine>
            </div>
          </el-tab-pane>
          <el-tab-pane label="反馈处理" name="Tab4" v-if="checkSendType == 'send'">
            <el-table :data="commentList"
                      style="width: 100%; margin: 20px"
                      size="mini"
                      max-height="300"
                      border>
              <el-table-column label="姓名" prop="createUserName"></el-table-column>
              <el-table-column label="时间" prop="createTime"></el-table-column>
              <el-table-column label="操作" prop="statusDisplayName"></el-table-column>
              <el-table-column label="内容" prop="comment"></el-table-column>
            </el-table>
            <div style="margin-top: 10px" v-if="checkCommitStatus != 1">
              <div style="margin-bottom: 10px">回复内容</div>
              <el-row>
                <el-col :span="16">
                  <el-input
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="commentTxt"
                          maxlength="50"
                          show-word-limit
                          rows="4"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="containerBox">
        <div class="btnMid">
          <el-button type="info" @click="close()">关 闭</el-button>

          <div class="btnList" v-show="activeName == 'Tab4' && checkCommitStatus != 1">
            <el-button type="info" @click="processChecker(1)">回 复</el-button>
            <el-button type="info" @click="processChecker(2)">处理完成</el-button>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getSendDetailService,
  getTypeListService,
  setCheckInternalService,
  getProcessCommentListService,
  processCheckerService,
  getInternalCheckService,
} from "@/services/documentServices";

import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem";
import {goBackApprove} from '@/page/approveComponents/approve';
import {previewFile} from "@/utils/index.js"
import {
  // exportExcelService2, //导出
  getTempUrlService //下载附件
} from "@/services/allContractServices";
export default {
  name: "detailAndApprove",
  data() {
    return {
      activeName: 'Tab1',
      type: 1,
      dataForm:{
        id:'', //id
        title: '',  //标题
        documentNum: '',  //发文字号
        documentTypeId: '',  //发文分类id
        documentDate: '',  //发文日期
        documentDraftDate: '',  //拟稿日期
        documentApproveDate: '',  //核稿日期
        sendListJson: [],  //主送
        ccListJson: [],  //抄送
        documentDraftDeptJson: [],  //部门
        remark: '',  //备注
        receiveUser: '', // 接收人
        operateUserName: '', // 处理人
        operateTime: '', // 处理时间
      },
      approveFlag: '', //审批状态
      approveType: "OFFICIAL_DOCUMENT_INTERNAL ", //审批类型
      subapproveType: '',
      contractId: 0,
      fileList:[],
      tableProps: [
        { prop: "name", label: "文件名称", width: "200px" },
        { prop: "uploadUserName", label: "上传者", width: "140px" },
        { prop: "uploadTime", label: "上传时间", width: "140px" },
      ],
      typeList: [], //发文分类列表
      commentList: [], //反馈列表
      pageIndex: 1,
      pageSize: 10,
      commentTxt: '',
      checkCommitStatus: '',
      checkSendType: '',
    }
  },
  components: {
    approveLine, //审批历史流程
    approveItem, //审批
  },
  methods: {
    onActive(menuCode) {
      if(this.tabRouteParam.id){
        this.dataForm.id = this.tabRouteParam.id;
        this.approveFlag = this.tabRouteParam
            ? this.tabRouteParam.approveFlag
            : "";
        this.contractId = Number(this.tabRouteParam.id);
        this.getSendDetail();
        this.type = this.tabRouteParam.type;
        if(this.type == 2){
          this.setCheckInternal();
        }
      }
      this.getTypeList();
    },
    //获取发文详情
    getSendDetail(){
      let paramsData = {
        systemFileInternalId: this.dataForm.id
      }
      getSendDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm = {
            id: res.data.id,
            title: res.data.title,  //标题
            documentNum: res.data.documentNum,  //发文字号
            documentTypeId: res.data.documentTypeId,  //发文分类id
            documentDate: res.data.documentDate,  //发文日期
            documentDraftDate: res.data.documentDraftDate,  //拟稿日期
            documentApproveDate: res.data.documentApproveDate,  //核稿日期
            sendListJson: res.data.sendListJson ? JSON.parse(res.data.sendListJson) : "",  //主送
            ccListJson: res.data.ccListJson ? JSON.parse(res.data.ccListJson) : "",  //抄送
            documentDraftDeptJson: JSON.parse(res.data.documentDraftDeptJson),  //部门
            remark: res.data.remark,  //备注
            receiveUser: '综合办',  //接收人
            operateUserName: res.data.operateUserName,  //处理人
            operateTime: res.data.operateTime,  //处理时间
            applyUserName: res.data.applyUserName,  //处理时间
          }
          this.fileList = res.data.attachmentList;

          if(res.data.sendStatus == 4){
            this.getInternalCheck();
            this.getProcessCommentList();
          }
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    getInternalCheck(){
      let params = {
        systemFileInternalId: this.dataForm.id,
      }
      getInternalCheckService(params).then( res => {
        if(res.code == 10000000){
          // this.commentList = res.data;
          this.checkCommitStatus = res.data.checkCommitStatus;
          this.checkSendType = res.data.checkSendType;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    getProcessCommentList(){
      let paramsData = {
        systemFileInternalId: this.dataForm.id,
        userId: sessionStorage.getItem('currentUserId'),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      getProcessCommentListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.commentList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //设置查阅
    setCheckInternal(){
      let paramsData = {
        systemFileInternalId: this.dataForm.id
      }
      setCheckInternalService(paramsData).then( res => {
        if(res.code == 10000000){

        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //查询发文分类列表
    getTypeList(){
      let paramsData = {
        pageIndex: 1,
        pageSize: 10000,
      }
      getTypeListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.typeList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //文件下载
    downloadFile(index, row) {
      let reqParam = {
        filePath: row.attachmentItem
      };
      getTempUrlService(reqParam).then(
          res => {
            if (res.code == 10000000) {
              //下载附件
              const link = document.createElement('a');
              // 这里是将链接地址url转成blob地址，
              fetch(res.data).then(res => res.blob()).then(blob => {
                link.href = URL.createObjectURL(blob)
                // 下载文件的名称及文件类型后缀
                link.download = row.name;
                document.body.appendChild(link)
                link.click()
                //在资源下载完成后 清除 占用的缓存资源
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              });
              // exportExcelService2(res.data).then(res1 => {
              //   this.$alert("下载成功", "提示", {
              //     confirmButtonText: "确定"
              //   });
              // });
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            }
          },
          err => {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
      );
    },
    //文件预览
    previewFile,
    processChecker(type) {
      if(this.commentTxt == ''){
        this.$message.error("请填写回复信息！");
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
          comment: type == 2 ? this.commentTxt : `回复${this.dataForm.applyUserName}：` + this.commentTxt,
          status: type,
          systemFileInternalId: this.dataForm.id
      }
      processCheckerService(params).then( res => {
        if(res.code == 10000000){
          this.commentTxt = '';
          this.$message.success('回复成功！');
          this.getProcessCommentList();
          if(type == 2){
            this.checkCommitStatus = 1;
          }
        }else{
          this.$message.error(res.msg);
        }
        loading.close();
      }).catch(error => {
        this.$message.error("网络请求失败");
        loading.close();
      });
    },
    // 关闭
    close(){
      if(this.approveFlag){
        goBackApprove(this.approveFlag,'processingDetails')
      }else{
        this.bus.$emit("tabClose", "processingDetails");
        this.bus.$emit("navMenuChange", {
          routeId: "documentManage"
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.addAndModify {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  .tabWrap {
    height: calc(100% - 60px);

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 140px);
        padding: 0 20px 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }
        .el-cascader {
          width: 100%;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }
}
.sendList {
  /deep/.el-form-item{
    width: 100%;
    display: flex;
    .el-form-item__content {
      width: 80%;
      display: flex;
      .el-input {
        flex: 1;
      }
      .el-button {
        margin-left: 10px;
        height: fit-content;
      }
    }
  }

  .tag-wrapper {
    border: 1px solid #dcdfe6;
    padding: 0 5px;
  }
}
.containerBox {
  width: 100%;
  height: 36px !important;
  position: fixed;
  bottom: 44px;
  left: 0;
  text-align: start;
}
.btnMid {
  position: relative;
  left: 27%;
  bottom: 0px;
  display: flex;
}
/deep/.ApproveItem .bottomBtn{
  bottom: 44px;
  z-index: 10;
}
  .btnList {
    margin-left: 15px;
  }
</style>
